// extracted by mini-css-extract-plugin
export default {"form":"Form_form__yyeVU","form__success":"Form_form__success__ihHaI","form__row":"Form_form__row__rBMLL","err":"Form_err__yR6i7","form__btn":"Form_form__btn__aclNr"};